import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import { createContext, Ref, useContext } from 'react';

type TFocusableElement = {
  id: string;
  ref: Ref<any>;
  order: number;
  group: FocusGroups;
  focusable: boolean;
};

type IFocusContext = {
  addFocusableElement: (focusableElement: TFocusableElement) => void;
  removeFocusableElement: (refID: TFocusableElement['id']) => void;
  changeFocusableElementProps: (changedProps: Partial<TFocusableElement>) => void;
  focusElement: (refID: TFocusableElement['id']) => void;
  blurElement: (refID: TFocusableElement['id']) => void;
  isFocused: (refID: TFocusableElement['id']) => boolean;
  makeOnlySomeElementGroupsFocusable: (group: TFocusableElement['group'][]) => void;
  makeAllElementGroupsFocusable: () => void;
  focusCloseFocusableElement: (needToFocusNextElement: boolean) => void;
};

const FocusContext = createContext<IFocusContext>({
  addFocusableElement: props => void 0,
  removeFocusableElement: () => void 0,
  changeFocusableElementProps: () => void 0,
  focusElement: () => void 0,
  blurElement: () => void 0,
  isFocused: () => false,
  makeOnlySomeElementGroupsFocusable: () => void 0,
  makeAllElementGroupsFocusable: () => void 0,
  focusCloseFocusableElement: () => void 0,
});

const useFocusContext = () => {
  return useContext(FocusContext);
};

export { useFocusContext, FocusContext, TFocusableElement };
